export type ChatBootstrapChannel = {
  id: string
  slug: string
  type: string
}

export const shouldBootstrapGeneralChannel = (
  channelsList: ChatBootstrapChannel[],
  defaultChannelId = 'workspace-chat',
  defaultChannelSlug = 'general',
  restricted = false,
): boolean => {
  if (restricted) return false
  const legacy = channelsList.find((channel) => channel.id === defaultChannelId)
  if (legacy && legacy.slug && legacy.slug !== legacy.id && legacy.type === 'public') return false
  if (channelsList.length > 0 && legacy && legacy.slug === defaultChannelSlug) return false
  return true
}
